import ConfigScreen from "../../../common/components/game-screens/ConfigScreen";
import React, {useState} from "react";
import { Input } from 'antd';
import Button from "../../../common/components/Button";
import T from "../../../common/i18n/Text";
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import {PageContainer} from "../../../common/components/page-container/PageContainer";
import {setItem} from "../../../common/firebase/db";
import {getUserId} from "../../../common/utils/storage";

enum PAGE_STATE {
    SUBMIT,
    THANKS
}

const { TextArea } = Input;

const LineSubmitPage = () => {
    const [submitting, changeSubmitting] = useState<boolean>(false);
    const [pageState, changePageState] = useState<PAGE_STATE>(PAGE_STATE.SUBMIT);
    const [lineValue, changeLineValue] = useState<string>("");
    let { gameId } = useParams();

    const updateLine = (event:any) => {
        changeLineValue(event.target.value);
    };

    const submitLine = async () => {
        changeSubmitting(true);
        const likeKey = getLineKey();
        await setItem(`/games/${gameId}/${likeKey}`, lineValue)
            .then(() => {
                changeSubmitting(false);
                changePageState(PAGE_STATE.THANKS);
            })
            .catch((error) => {
                console.error(error)
                changeSubmitting(false);
            });

    };

    const reSubmitLine = () => {
        changeLineValue("");
        changePageState(PAGE_STATE.SUBMIT);
    };

    const { t } = useTranslation();
    const placeholder = t('games.lines.lineSubmit.placeholder');

    const inputComponent = [
      <TextArea
          className="max-sm:w-full sm:w-[474px] md:w-[474px] mb-5"
          placeholder={placeholder}
          value={lineValue}
          onChange={updateLine}
          rows={6}
          key="line"
      />,
      <Button key="btn" type="primary" onClick={submitLine} disabled={lineValue.length === 0} loading={submitting} name="lines-line-submit">
          <T path="games.lines.lineSubmit.submit"/>
      </Button>
    ];

    const thanksComponent = <Button key="btn" type="secondary" onClick={reSubmitLine} name="lines-line-resubmit">
        <T path="games.lines.lineSubmit.reSubmit"/>
    </Button>;

    const content = pageState === PAGE_STATE.SUBMIT ? inputComponent : thanksComponent;

    const titlePath = pageState === PAGE_STATE.SUBMIT ? "games.lines.lineSubmit.title" : "games.lines.lineSubmit.thankYou";

    return <PageContainer>
        <ConfigScreen
            configTitlePath={titlePath}
            showActionButtons={false}
        >
            {content}
        </ConfigScreen>
    </PageContainer>;
};

const getLineKey = () => {
    return getUserId() + '-' + new Date().getTime();
};

export default LineSubmitPage;
